import React from 'react';
import { Link } from 'react-router-dom';
import ExamBadge from '../common/ExamBadge';

const PIPELINE_STEPS = [
  { key: 'sources_status',      label: 'Sources' },
  { key: 'mapping_status',      label: 'Mapping' },
  { key: 'ckb_status',          label: 'CKB' },
  { key: 'blueprint_status',    label: 'Blueprint' },
  { key: 'question_bank_status', label: 'Question Bank' },
];

function PipelineMini({ project }) {
  return (
    <div style={{ display: 'flex', gap: 4, alignItems: 'center', marginTop: 10, flexWrap: 'wrap' }}>
      {PIPELINE_STEPS.map(({ key, label }) => {
        const status = project[key] || 'pending';
        const dotColor =
          status === 'ready' ? 'var(--exam-success)'
          : status === 'generating' || status === 'processing' ? 'var(--exam-warning)'
          : status === 'error' ? 'var(--exam-error)'
          : 'var(--exam-border-strong)';
        return (
          <div key={key} style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
            <span style={{
              width: 7, height: 7, borderRadius: '50%', background: dotColor,
              display: 'inline-block', flexShrink: 0,
            }}/>
            <span style={{ fontSize: 11, color: 'var(--exam-text-muted)', fontWeight: 500 }}>
              {label}
            </span>
          </div>
        );
      })}
    </div>
  );
}

function formatDate(iso) {
  if (!iso) return '';
  return new Date(iso).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
}

export default function ProjectCard({ project, onDelete }) {
  return (
    <div className="exam-card" style={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
      {/* Header */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 8 }}>
        <div style={{ flex: 1, minWidth: 0 }}>
          <Link
            to={`/examination/projects/${project.id}`}
            style={{ textDecoration: 'none' }}
          >
            <h3 style={{
              margin: 0, fontSize: 14, fontWeight: 600, color: 'var(--exam-text)',
              whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis',
            }}>
              {project.title}
            </h3>
          </Link>
          <p style={{ margin: '3px 0 0', fontSize: 12, color: 'var(--exam-text-muted)' }}>
            {[project.course_code, project.semester, project.batch].filter(Boolean).join(' · ') || 'No details'}
          </p>
        </div>
        <ExamBadge status={project.status} label={project.status} dot />
      </div>

      {/* Pipeline mini status */}
      <PipelineMini project={project} />

      {/* Footer */}
      <div className="exam-divider" />
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 8 }}>
        <div style={{ display: 'flex', gap: 6 }}>
          <ExamBadge label={project.exam_type} status={project.exam_type} />
          <ExamBadge label={project.assessment_type} status={project.assessment_type} />
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <span style={{ fontSize: 11, color: 'var(--exam-text-muted)' }}>
            {formatDate(project.updated_at)}
          </span>
          <Link
            to={`/examination/projects/${project.id}`}
            className="exam-btn exam-btn-outline exam-btn-sm"
          >
            Open
          </Link>
        </div>
      </div>
    </div>
  );
}
